import axios from 'axios';

export const loc = window.location;

export const baseUrl = window._env_ && window._env_.REACT_APP_BASE_URL ? window._env_.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : loc.origin;

export const apiUrl = () => {
  if (window._env_ && window._env_.REACT_APP_API_BASE_URL){
    return window._env_.REACT_APP_API_BASE_URL;
  }
  return axios.get(window._env_.REACT_APP_CENTRAL_BASE_URL + 'd-retrieve')
  .then((response) => {
    window._env_={'REACT_APP_API_BASE_URL': 'https://' + response.data.domain + '/api'};
    return  window._env_.REACT_APP_API_BASE_URL;
  });
}
